<template lang="pug">
.faq-accordion
  .faq-accordion__item(
    v-for="(item, index) in items"
    :key="item.pergunta"
  )
    button.faq-accordion__trigger(
      type="button"
      :aria-expanded="expandedIndex === index"
      @click="toggle(index)"
    )
      span.faq-accordion__question {{ item.pergunta }}
      img.faq-accordion__chevron(
        src="@/assets/icons/editais/chevron-down.svg"
        alt=""
        :class="{ 'faq-accordion__chevron--open': expandedIndex === index }"
      )
    .faq-accordion__panel(v-show="expandedIndex === index")
      p.faq-accordion__answer {{ item.resposta }}
</template>

<script>
export default {
  name: 'FaqAccordion',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      expandedIndex: null
    }
  },
  methods: {
    toggle (index) {
      this.expandedIndex = this.expandedIndex === index ? null : index
    }
  }
}
</script>

<style lang="scss" scoped>
.faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.faq-accordion__item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.faq-accordion__trigger {
  align-items: center;
  background: #ffffff;
  border: none;
  cursor: pointer;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 16px;
  text-align: left;
  width: 100%;
}

.faq-accordion__question {
  color: #727272;
  font-family: 'Poppins', 'Ubuntu', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.55;
}

.faq-accordion__chevron {
  display: block;
  flex-shrink: 0;
  height: 24px;
  transition: transform 0.2s ease;
  width: 24px;

  &--open {
    transform: rotate(180deg);
  }
}

.faq-accordion__panel {
  border-top: 1px solid #e5e7eb;
  padding: 0 16px 16px;
}

.faq-accordion__answer {
  color: #4c4c4c;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  margin: 16px 0 0;
}
</style>
